import * as React from "react";
import {getInputClassName} from "../../CommonFunctions";

interface IProps {
    showErrorMessage?: boolean;
    errorText?: string;
    questionLabel: React.ReactNode;
    isValid?: boolean;
    onChange: (event: any) => void;
    id: string;
    maxLength: number;
    value: string;
    largeTextArea: boolean;
}

export class TextAreaComponent extends React.Component<IProps> {

    public render(): React.ReactNode {
        const cssClass: string = this.props.largeTextArea ? "description-textarea large" : "description-textarea";

        return (
            <div className="form-group pb-2">
                <label htmlFor={this.props.id}>{this.props.questionLabel}</label>
                <textarea
                    className={`${getInputClassName(this.props.isValid)} ${cssClass}`}
                    id={this.props.id}
                    maxLength={this.props.maxLength}
                    value={this.props.value}
                    onChange={this.props.onChange}
                    onClick={this.props.onChange}/>
                {this.props.showErrorMessage &&
                    <div className="mb-3 invalid-feedback d-block">{this.props.errorText}</div>
                }
            </div>
        )
    }
}
